import React, { Component } from 'react';
import { Spin, Button } from 'antd';
import _notification from 'modules/notification';

import InterviewCallLetter from './InterviewCallLetter';
// Interview Marks Workflow & Final Result Foundation phase: StudentAppointmentLetter.jsx and its full
// backend (StudentAppointmentServices/StudentAppointmentController) were already fully built, but the
// only code that ever linked them into the live candidate journey (the old, orphaned ResultCard.jsx)
// was dead code never actually rendered by the app — this is the first time a candidate can reach it.
import StudentAppointmentLetter from './StudentAppointmentLetter';

import _AdminService from 'modules/AdminService';
import _InterviewScheduleService from 'modules/InterviewScheduleService';


import { GENERAL_ERROR_MESSAGE, SHOW_INTERVIEW_MARKS_FOR_PASS_CANDIDATE } from 'constants/constants';


class ResultCard_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            StudentMessage: "",
            result: "",
            marks: 0,
            // Candidate Result Display Accuracy phase: needed to tell a genuine written-exam
            // "Absent" outcome apart from an ordinary Fail — an absent candidate has no marks to
            // show at all, only the message (see render()).
            attendance: "",
            loading: false,
            viewInterviewCallLetter: false,
            InterviewMarks: 0,
            Post: "",
            // Primary Result Automation & Interview Shortlisting phase.
            isInterviewShortlisted: false,
            interviewShortlistMessage: "",
            // Interview Marks Workflow & Final Result Foundation phase.
            viewAppointmentLetter: false,
            isFinalResultPublished: false,
            // Final Result, Selected/Waiting Publication & Appointment Letter Closure phase: the
            // authoritative, structured final status returned by the API — only ever populated once
            // IsFinalResultPublished === true. Drives the Appointment Letter button; StudentMessage
            // text is never inspected for this decision.
            finalStatus: null,
            // Candidate Journey Artifact Stabilization phase: the candidate's own Interview Schedule
            // (Phase B/C), fetched alongside the Result so the Call Letter action can be exposed right
            // here, together with the Primary Result, instead of only from the separate Interview
            // Schedule tab. `null` until loaded / if no schedule exists yet for this candidate — every
            // read below is null-safe. This never bypasses the server-side release check: the button
            // below is gated on `schedule.IsCallLetterReleased`, and clicking through still renders the
            // same InterviewCallLetter component, which independently re-verifies release status itself.
            schedule: null
        };
    }

    componentDidMount() {
        this.GetStudentResultByApplicationId();
        this.getInterviewSchedule();
    }

    // Best-effort, non-blocking — a candidate with no schedule yet (not shortlisted, or shortlisted but
    // not yet scheduled) simply keeps `schedule: null`, and every gate below already treats that as
    // "nothing to show here," matching InterviewSchedule.jsx's own graceful empty-state convention.
    getInterviewSchedule = async () => {
        try {
            const response = await _InterviewScheduleService.getForCandidate();
            if (response.status === 200 && response.data) {
                this.setState({ schedule: response.data });
            }
        } catch (e) {
            // silent — this is a supplementary action surface, not the primary Result content
        }
    }
    GetStudentResultByApplicationId = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let response = await _AdminService.GetStudentResultByApplicationId();

                    let data = response.data;
                    if (data.IsSuccess) {
                        let resultData = data.Obj;
                        let StudentMessage = resultData.StudentMessage;
                        let result = resultData.Result;
                        let marks = resultData.Marks;
                        let InterviewMarks = resultData.InterviewMarks
                        let Post = resultData.Post
                        this.setState({
                            ...this.state,
                            StudentMessage: StudentMessage,
                            result: result,
                            marks: marks,
                            attendance: resultData.Attendance,
                            loading: false,
                            InterviewMarks: InterviewMarks,
                            Post,
                            // Primary Result Automation & Interview Shortlisting phase: when true, the
                            // server has already withheld Marks/CorrectMarks/InCorrectMarks/UnSolved/
                            // InterviewMarks from this same response (never merely hidden client-side) —
                            // this candidate must never see their examination marks before interview.
                            isInterviewShortlisted: resultData.IsInterviewShortlisted === true,
                            interviewShortlistMessage: resultData.InterviewShortlistMessage,
                            // Interview Marks Workflow & Final Result Foundation phase.
                            isFinalResultPublished: resultData.IsFinalResultPublished === true,
                            // Final Result, Selected/Waiting Publication & Appointment Letter Closure phase.
                            finalStatus: resultData.FinalStatus
                        });
                    }
                    else {
                        let StudentMessage = "You have been absent for the exam.";
                        this.setState({
                            ...this.state,
                            StudentMessage: StudentMessage,
                            loading: false,
                        });
                    }


                }
                catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }

    interviewCallLetter = () => {
        this.setState({
            viewInterviewCallLetter: true
        })
    }

    appointmentLetter = () => {
        this.setState({
            viewAppointmentLetter: true
        })
    }

    render() {
        if (this.state.loading)
            return <div role="status" aria-live="polite"><Spin size="large" /></div>
        if (this.state.viewInterviewCallLetter) {
            return <InterviewCallLetter
                onTabOrderChange={this.props.onTabOrderChange}
                data={this.props.data}
            />
        }
        if (this.state.viewAppointmentLetter) {
            return <StudentAppointmentLetter
                onTabOrderChange={this.props.onTabOrderChange}
            />
        }

        // Candidate Result Display Accuracy phase: InterviewMarks can legitimately hold non-numeric
        // text ("Absent"/"Disqualified") for candidates who reached the interview stage but never
        // received a numeric score — parseInt on those yields NaN, so Total is only ever shown when
        // both components are genuine numbers; otherwise the Total row is simply omitted (Exam Marks
        // and the textual Interview Marks value are still shown on their own rows either way).
        const parsedExamMarks = parseInt(this.state.marks, 10);
        const parsedInterviewMarks = parseInt(this.state.InterviewMarks, 10);
        const totalMarks = parsedExamMarks + parsedInterviewMarks;
        const hasNumericTotal = !isNaN(parsedExamMarks) && !isNaN(parsedInterviewMarks);
        // True once a shortlisted candidate's Final Result is live — the point at which the confirmed
        // production business rule says Exam Marks + Interview Marks become visible again, for every
        // outcome (Selected/Waiting/NotSelected/Absent/Disqualified) alike.
        const showInterviewStageMarks = this.state.isInterviewShortlisted && this.state.isFinalResultPublished;

        return (

                 <div className="candidate-result ch-container gl-bxbr analysisWrap p-4 mt-4">
                    {/* Candidate Journey Artifact Stabilization phase — real defect fix: the backend
                        (StudentResultService, "Primary Result Automation & Interview Shortlisting" phase)
                        deliberately stops sending InterviewShortlistMessage once Final Result is
                        published, on the documented assumption that this component would then fall back
                        to StudentMessage — but this line never actually did that, it always preferred
                        interviewShortlistMessage whenever isInterviewShortlisted was true, regardless of
                        publication state. Every shortlisted candidate whose Final Result had been
                        published saw a BLANK message bar (interviewShortlistMessage had gone null,
                        nothing else was shown) — confirmed live (candidate 95004, Selected). Fixed to
                        match the backend's own documented intent: show the shortlist holding message only
                        while Final Result is not yet published; fall back to the real StudentMessage
                        (Selected/Waiting/NotSelected/Absent/Disqualified wording) once it is. */}
                    <h4 role="status" aria-live="polite" className={this.state.result === "Fail" ? "ch-heading4 mb-4 text-center fail" : "ch-heading4 mb-4 text-center pass"}>
                        {this.state.isInterviewShortlisted && !this.state.isFinalResultPublished
                            ? this.state.interviewShortlistMessage
                            : this.state.StudentMessage}
                    </h4>
                    {/* Candidate Journey Artifact Stabilization phase — minor visual defect fix: this
                        container previously always rendered, even when neither branch below has
                        anything to show (e.g. a non-shortlisted Pass candidate when
                        SHOW_INTERVIEW_MARKS_FOR_PASS_CANDIDATE is false, a real, intentional config
                        value in this environment) — leaving a visibly empty gray box under the message.
                        Now only rendered when it will actually contain something. */}
                    {(!this.state.isInterviewShortlisted && this.state.result === "Fail" && this.state.attendance !== "Absent") ||
                     (!this.state.isInterviewShortlisted && this.state.result === "Pass" && SHOW_INTERVIEW_MARKS_FOR_PASS_CANDIDATE) ||
                     showInterviewStageMarks ? (
                    <div className="candidateform-cover pt-3 pr-3 pl-3 pb-2 candidate-result-wrap">
                        <div className="container-fluid  pr-0 pl-0 overflow-hidden">
                            <div className="row result-row pt-3">
                                {/* Primary Result Automation & Interview Shortlisting phase: a shortlisted
                                    candidate never sees Marks/Correct/Incorrect/Unsolved/InterviewMarks
                                    while Final Result is still pending — the message above is the only
                                    thing rendered for them then (the underlying fields are already null in
                                    the API response, not merely hidden here). Once Final Result is
                                    published, the showInterviewStageMarks block below takes over instead.
                                    Candidate Result Display Accuracy phase: also skipped for a genuine
                                    exam-Absent candidate — there are no marks to show, only the message. */}
                                {!this.state.isInterviewShortlisted && this.state.result === "Fail" && this.state.attendance !== "Absent" && (
                                    <div className="mb-2 col-sm-12 pb-3 d-flex ent-marks-obtained-prominent">
                                        <label className="font-weight-bold">{"Marks Obtained: "}&nbsp;</label>
                                        <label>{this.state.marks}</label>
                                    </div>
                                )}
                                {!this.state.isInterviewShortlisted && this.state.result === "Pass" && SHOW_INTERVIEW_MARKS_FOR_PASS_CANDIDATE && (
                                    <>
                                        <div className="mb-2 col-sm-12 mb-3 d-flex">
                                            <label className="font-weight-bold">{"Post: "}&nbsp;</label>
                                            <label>{this.state.Post}</label>
                                        </div>
                                        <div className="mb-2 col-sm-12 mb-3 d-flex">
                                            <label className="font-weight-bold">{"Marks: "}&nbsp;</label>
                                            <label>{this.state.marks}</label>
                                        </div>
                                        <div className="mb-2 col-sm-12 mb-3 d-flex">
                                            <label className="font-weight-bold">{"Interview Marks: "}&nbsp;</label>
                                            <label>{this.state.InterviewMarks}</label>
                                        </div>
                                        <div className="mb-2 col-sm-12 mb-3 d-flex">
                                            <label className="font-weight-bold" >{"Total Marks: "}&nbsp;</label>
                                            <label>{totalMarks}</label>
                                        </div>
                                    </>
                                )}
                                {/* Candidate Result Display Accuracy phase: every candidate who actually
                                    reached the interview stage sees Exam Marks + Interview Marks here once
                                    Final Result is published, regardless of outcome (Selected/Waiting/
                                    NotSelected both use this same block; Absent/Disqualified show their
                                    textual InterviewMarks value here too — "Absent"/"Disqualified" is the
                                    real stored value, not a placeholder). Total Marks only appears when
                                    both components are genuine numbers. */}
                                {showInterviewStageMarks && (
                                    <>
                                        <div className="mb-2 col-sm-12 mb-3 d-flex">
                                            <label className="font-weight-bold">{"Post: "}&nbsp;</label>
                                            <label>{this.state.Post}</label>
                                        </div>
                                        <div className="mb-2 col-sm-12 mb-3 d-flex">
                                            <label className="font-weight-bold">{"Exam Marks: "}&nbsp;</label>
                                            <label>{this.state.marks}</label>
                                        </div>
                                        <div className="mb-2 col-sm-12 mb-3 d-flex">
                                            <label className="font-weight-bold">{"Interview Marks: "}&nbsp;</label>
                                            <label>{this.state.InterviewMarks}</label>
                                        </div>
                                        {hasNumericTotal && (
                                            <div className="mb-2 col-sm-12 mb-3 d-flex">
                                                <label className="font-weight-bold" >{"Total Marks: "}&nbsp;</label>
                                                <label>{totalMarks}</label>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>

                    </div>
                    ) : null}

                    {/* Candidate Journey Artifact Stabilization phase: this used to be gated on the
                        static, no-admin-toggle `DOWNLOAD_INTERVIEW_CALL_LETTER` env flag (defaulting
                        false in every environment, with nothing in the app able to turn it on) stacked
                        on top of a bare `result === "Pass"` check — meaning it never actually reflected
                        whether the candidate was interview-shortlisted, let alone whether the Call
                        Letter had actually been released. Now gated on the same real, admin-controlled
                        signals the rest of the journey already uses: shortlisted AND the schedule's own
                        IsCallLetterReleased flag. This is additive — the separate Interview Schedule tab
                        (dashboard → "Interview Schedule") still exists unchanged as its own entry point;
                        this just also surfaces the same action alongside the Primary Result, since the
                        real-world release pattern doesn't always insert an artificial gap between them.

                        Production Candidate Journey Correction phase — real defect fix: this block was
                        missing the `!isFinalResultPublished` guard, so once a shortlisted candidate's
                        Final Result was published, they saw "View Interview Schedule" / "View/Download
                        Interview Call Letter" AND the Appointment Letter action at the same time — the
                        exact defect reported for Roll 1004 ("simultaneously shown an Interview Call
                        Letter and 'Congratulations, you have been selected'"). The journey states must
                        be sequential and mutually exclusive (examination → shortlist → interview stage
                        → final outcome): once Final Result is published, the candidate has moved past
                        the interview stage entirely, so this row now hides and only the final-outcome
                        section below (message + Appointment Letter, if selected) is shown. The candidate
                        does not lose access to their Call Letter by this change — it was for the
                        now-concluded interview appointment, not an ongoing entitlement. */}
                    {this.state.isInterviewShortlisted && !this.state.isFinalResultPublished && this.state.schedule && (
                        <div className="row mt-4 footer-buttons">
                            <div className="col-12">
                                <div className="form-action d-flex justify-content-center flex-wrap">
                                    <Button
                                        className="button-global button-border autoHeight ml-4 mb-2 autoWidth"
                                        onClick={() => this.props.onTabOrderChange(12)}
                                    >View Interview Schedule
                                    </Button>
                                    {this.state.schedule.IsCallLetterReleased && (
                                        <Button
                                            className="button-global button-primary autoHeight ml-4 mb-2 autoWidth"
                                            onClick={() => this.interviewCallLetter(9)}
                                        >View / Download Interview Call Letter
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Final Result, Selected/Waiting Publication & Appointment Letter Closure phase:
                        gated solely on the authoritative, structured FinalStatus === "Selected" returned
                        by the API — never a StudentMessage text match. Waiting/NotSelected/Absent/
                        Disqualified candidates never see this button; also enforced server-side
                        (StudentAppointmentServices.GetStudentAppointmentDataByRoleNumber) so this is
                        defense-in-depth, not the only gate. Reuses the fully-existing, previously-
                        unreachable Appointment Letter mechanism as-is. The `DOWNLOAD_APPOINTMENT_LETTER`
                        env flag (same class of issue as the Call Letter flag above — static, no admin
                        toggle, defaults false) no longer gates this; FinalStatus is the real,
                        admin-controlled release decision. */}
                    {this.state.isFinalResultPublished && this.state.finalStatus === 'Selected' &&
                        <div className="row mt-4 footer-buttons">
                            <div className="col-12">
                                <div className="form-action d-flex justify-content-center ">
                                    <Button
                                        className="button-global button-primary autoHeight ml-4 autoWidth"
                                        onClick={() => this.appointmentLetter()}
                                    >Click here to download appointment letter
                                    </Button>

                                </div>
                            </div>
                        </div>
                    }
                         
                 </div> 
          
        )
    };
}

export default ResultCard_new;